export default "__VITE_ASSET__XMfmZ6p___"